import { CapoPlugin } from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];